/**
 * Antioch Agent brand mark — a single, filled four-point sparkle.
 *
 * Drawn inline (no Lucide dependency) so we can keep the geometry
 * crisp at the small sizes used by the menu bar (~14px) and the
 * pane topbar's icon tile. Concave joins between the four arms
 * give it a distinctly modern, deliberate silhouette so it reads
 * as a primary product mark instead of a generic "AI star".
 *
 * Always rendered in ``currentColor``. The default tone is Antioch
 * Agent blue; callers can still override with ``text-*`` when the
 * mark sits inside an already-colored surface. The default size is
 * ``size-3.5`` (14px), matching the rest of our toolbar icons.
 */

import { cn } from '@/lib/utils/cn';

export interface AntiochAgentIconProps {
  className?: string;
}

export function AntiochAgentIcon({ className }: AntiochAgentIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={cn('size-3.5 shrink-0 text-blue-500 dark:text-blue-300', className)}
    >
      <path d="M12 1.5a.75.75 0 0 1 .724.555l1.624 5.94a2.25 2.25 0 0 0 1.582 1.582l5.94 1.624a.75.75 0 0 1 0 1.448l-5.94 1.624a2.25 2.25 0 0 0-1.582 1.582l-1.624 5.94a.75.75 0 0 1-1.448 0l-1.624-5.94a2.25 2.25 0 0 0-1.582-1.582l-5.94-1.624a.75.75 0 0 1 0-1.448l5.94-1.624A2.25 2.25 0 0 0 9.652 7.995l1.624-5.94A.75.75 0 0 1 12 1.5z" />
    </svg>
  );
}
